import { Modal } from 'bootstrap-v5';
import { Tooltip } from 'bootstrap-v5';
import { jarallax } from "jarallax";
import {initCalculator} from "./calculator";
import {slideToContactForm} from "@/front/js/slideToContact";
import {initAjaxVariantChanger} from "@/front/js/categoryVariantChanger";
import {initShoppingCartInsert} from "@/front/js/shoppingCartInsert";
import {initIframeCookies} from "@/front/js/components/iframeCookies";
import { initHellobar } from "@/front/js/components/hellobar";

const maxSmallSize = 767;

$.nette.ext('jsplugins', {
	success: function (payload) {
		if (payload.snippets !== undefined) {
			let snippets = payload.snippets;

			for (let key in snippets) {
				// skip loop if the property is from prototype
				if (!snippets.hasOwnProperty(key))
					continue;

				initPlugins($("#" + key));
			}
		}
	}
});

$.nette.ext('javascript', {
	success: function (payload) {
		if (payload.javascript) {
			eval(payload.javascript);
		}
	}
});

$.nette.ext('history', {
	success: function (payload) {
		if (payload.url !== undefined) {
			history.replaceState({}, document.title, payload.url);
		}
	}
});

$.nette.ext('pagination', {
	success: function (payload) {
		if (payload.paginated !== undefined) {
			document.querySelector("[data-after-paging-target]").scrollIntoView({behavior: "smooth"});
		}
	}
});

$.nette.ext('modal', {
	success: function (payload) {
		let flashMessageEls = document.querySelectorAll(".flash-message");

		flashMessageEls.forEach(function(el) {
			let modal = new Modal(el, {});
			modal.show();
		});
	}
});

$.nette.init();

initPlugins($(document));
initShoppingCartInsert();
initHellobar();

function initPlugins(scope){

	//Fancybox for images inserted by tinyMCE
	$(".tinyMceText img", scope).wrap(function (foo) {
		if(!$(this).parent().is("a")) {
			return "<a href='" + $(this).attr("src") + "' data-fancybox/>";
		}
	}).addClass("img-fluid");

	$(".tinyMceText table", scope).addClass("table");

	//Justified gallery
	$(".justified-gallery", scope).justifiedGallery({
		rowHeight : 140,
		lastRow : 'nojustify',
		margins : 10,
		captions: true
	});

	//complex vertical menu
	$(".complex-vertical-menu", scope).each(function(){
		let submenu = $(this);
		$(".toggleSubmenu", submenu).on("click", function(){
			let toggler = $(this);
			let id = toggler.data("id");

			$("#" + id).toggleClass("opened");
			$("#submenu-" + id).collapse("toggle");

			return false;
		})
	});

	//Submit on change
	$(".submitOnChange", scope).change(function(){
		$(this).closest("form").submit();
	});

	initCalculator(scope);

	if (document.documentElement.clientWidth <= maxSmallSize) {
		initSlideVideo();
	}

	slideToContactForm();
}

let flashMessageEls = document.querySelectorAll(".flash-message");
flashMessageEls.forEach(function(el) {
	let modal = new Modal(el, {});
	modal.show();
});

jarallax(document.querySelectorAll(".jarallax"), {
	speed: 0.2,
});

function initSlideVideo() {
	const videoSlide = document.querySelector(".video-slide");
	if (videoSlide !== null) {
		videoSlide.classList.remove("swiper-slide");
	}
}

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new Tooltip(tooltipTriggerEl)
})

initAjaxVariantChanger(".products-list .color");
initAjaxVariantChanger(".product-description .color");
initIframeCookies();
